module.exports = __webpack_public_path__ + "img/talk.b47318f9.svg";